<app-header></app-header>
<app-menu-sidebar class="sidebar-dark-primary"></app-menu-sidebar>
<div class="content-wrapper">
    <div class="inner-content-wrap">
        <router-outlet></router-outlet>
    </div>
</div>
<div id="sidebar-overlay" (click)="onToggleMenuSidebar()"></div>
